/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React from 'react';


export const useIsOverflow = (ref: React.MutableRefObject<HTMLElement | null>) => {
  const [isOverflow, setIsOverflow] = React.useState(false);
  React.useLayoutEffect(() => {
    const current = ref.current;
    if (current) {
      setIsOverflow(current.scrollHeight > current.clientHeight);
    }
  }, [ref]);
  return isOverflow;
};
